<template>
<div  :class="`weather_wrapper h-100 w-100`">

    <div :class="`add h-100 `">

      <div class="text-center h-100" v-if="!weatherData?.base" :style="{ backgroundColor: transparentbg === true ? 'none !important' : bgColor }">
                <h1 class="mb-0">Search Location for Weather forcast</h1>
      </div>

      <div v-else :def-w='defautlTextWidth' :class="`Overlay-side `" :style="{ backgroundColor: transparentbg === true ? 'none !important' : bgColor }">
        <div :class="`h-100 ${layout === 'sv2' || layout === 'sv3' ? 'd-inline-block' : '' }`" v-if="layout === 'sv1'">
          <div class="text-center d-flex align-items-center justify-content-center w-100 mx-0 Overlay-side position-unset" :style="{ backgroundColor: transparentbg === true ? 'none !important' : bgColor }">
            <h2 class="responsive_heading   mb-0 align-self-center mt-2 text-right"   :style="{color:color,fontFamily:fontfamily,fontSize :fontSize + 'px'}">{{ T('TODAY') }} </h2>
            <div class=""> <weatherIcon :style="{width: width * 0.30 + 'px'}" v-bind:weather_code="weatherData?.weather[0]?.icon" ></weatherIcon></div>
            <h2 class="responsive_heading   mb-0 align-self-center mt-2 text-left"   :style="{color:color,fontFamily:fontfamily,fontSize : fontSize + 'px'}">{{`${weatherData?.main?.temp ? Math.round(weatherData?.main?.temp) + '&deg;' : '' }`}}{{unit}}</h2>
          </div>
        </div>
        <div def-fs="22" :class="`h-100 ${layout === 'sv1' || layout === 'sv2' || layout === 'sv3' ? 'd-inline-block' : '' }`" v-if="layout === 'sv2'">
          <div class="text-center   w-100 mx-0 Overlay-side position-unset" :style="{ backgroundColor: transparentbg === true ? 'none !important' : bgColor }">
           <div class="d-inline-block">
              <h2 class="responsive_heading   mb-0 align-self-center mt-2" :style="{color:color,fontFamily:fontfamily,fontSize : fontSize +  'px'}">{{city?.name?.split(",")[0]}}</h2>
              <div class="d-inline-flex align-items-center justify-content-between">
                <div class=""> <weatherIcon :style="{width: width * 0.50 + 'px'}" v-bind:weather_code="weatherData?.weather[0]?.icon" ></weatherIcon></div>
                  <h2 class="responsive_heading   mb-0 align-self-center mt-2" :style="{color:color,fontFamily:fontfamily,fontSize : fontSize +  'px'}">{{`${weatherData?.main?.temp ? Math.round(weatherData?.main?.temp) + '&deg;' : '' }`}}{{unit}}</h2>
                </div>
            </div>
          </div>
        </div>
        <div def-fs="22" :class="`h-100 ${layout === 'sv1' || layout === 'sv2' || layout === 'sv3' ? 'd-inline-block' : '' }`" v-if="layout === 'sv3'">
          <div class="text-center d-flex align-items-center justify-content-center  w-100 mx-0 Overlay-side position-unset" :style="{ backgroundColor: transparentbg === true ? 'none !important' : bgColor }">
           <div class=""> <weatherIcon :isDisplayInline="false" :style="{width: width * 0.50 + 'px'}" v-bind:weather_code="weatherData?.weather[0]?.icon" ></weatherIcon></div>
            <h2 class="responsive_heading   mb-0 align-self-center mt-2" :style="{color:color,fontFamily:fontfamily,fontSize : fontSize + 'px'}">{{`${weatherData?.main?.temp ? Math.round(weatherData?.main?.temp) + '&deg;' : '' }`}}{{unit}}</h2>
          </div>
        </div>
        <div v-if="layout === 'fv1'" class="d-flex flex-column align-items-center justify-content-between h-100">

          <div :class="`adjustBottomSection `" >
            <div class="row mx-0 h-100 align-items-center">
              <div class="col-4 head1" v-for="(item, index) of filter3daysArr" v-bind:key="index">
                  <div class="margin-bottom-minus" :style="{color:color,fontFamily:fontfamily, fontSize : fontSize + 'px'}">{{T(getDayName(item.dt_txt))}}</div>
                  <div class="d-inline-flex  justify-content-between">

                <div class=""> <weatherIcon :style="{width: width * 0.15 + 'px'}" v-bind:weather_code="item?.weather[0]?.icon" ></weatherIcon></div>
                  <h2 class="responsive_heading   mb-0 align-self-center " :style="{color:color,fontFamily:fontfamily,fontSize : fontSize + 'px'}">{{`${Math.round(item?.main?.temp)}&deg;`}}{{unit}}</h2>
                </div>
                <div class="margin-top-minus" :style="{color:color,fontFamily:fontfamily,fontWeight:400, fontSize : fontSize *0.45 + 'px'}">{{T(item?.weather[0]?.description)}}</div>

              </div>

            </div>
          </div>
        </div>
        <div v-if="layout === 'fv2'" class="d-flex flex-column align-items-center justify-content-between h-100">
          <div :class="`adjustBottomSection `" >
            <div class="row mx-0 h-100 align-items-center">
              <div :class="`col-4 head1 ${index === 0 ? 'pr-4' : ''} ${index === 2 ? 'pl-4' : ''}`" v-for="(item, index) of filter3daysArr" v-bind:key="index">
                <div class="text-center d-flex align-items-center justify-content-center px-3 w-100 mx-0 Overlay-side position-unset" :style="{ backgroundColor: transparentbg === true ? 'none !important' : bgColor }">
                  <h2 class="responsive_heading   mb-0 align-self-center mt-2" :style="{color:color,fontFamily:fontfamily,fontSize : fontSize  + 'px'}">{{T(getDayName(item.dt_txt))}} </h2>
                  <!-- <weatherIcon :class="`${width <= breakpoints && width >= breakpointshalf ? 'w-50' : 'w-25'} `"></weatherIcon> -->
                  <div class="px-1"> <weatherIcon :style="{width: width * 0.12 + 'px'}" v-bind:weather_code="item?.weather[0]?.icon"></weatherIcon></div>
                    <h2 class="responsive_heading   mb-0 align-self-center mt-2" :style="{color:color,fontFamily:fontfamily,fontSize : fontSize + 'px'}">{{`${Math.round(item?.main?.temp)}&deg;`}}{{unit}}</h2>
                  </div>

              </div>

            </div>
          </div>
        </div>
      </div>


    </div>
</div>
</template>
<script>
import axios from "axios";
import moment from 'moment';
import weatherIcon from "../../utils/weatherIcon.vue"
import {translateWeather} from "../../utils/WeatherTranslation"
export default {
    name:"weatherApp",
    components:{
      weatherIcon,
    },
    props: {
             width: Number,
             zoom: Number,
             height:Number,
             city:Object,
             unit:String,
             showForcast:Boolean,
             color:String,
             bgColor:String,
             layout:String,
             fontfamily:String,
             lang:String,
             transparentbg:Boolean,
             fontSize:Number
    },
    computed:{
        checkDay(){
            return this.weatherData?.current?.is_day === 0
        },
        getActiveCanvas() {
            return this.$store.getters.getCurrentActiveCanvas
        },
        filter3daysArr(){
            debugger // eslint-disable-line no-debugger
            const uniqueDates = {};
            const filteredData = [];

            this.forecastData?.list?.forEach(item => {
                const date = item.dt_txt.split(' ')[0]; // Extracting the date part from dt_txt
                if (!uniqueDates[date]) {
                    uniqueDates[date] = true;
                    filteredData.push(item);
                }
            });

            let newarr = filteredData;
            // console.log(newarr)
            if(newarr && newarr.length > 0){
                 newarr.splice(3);
                //  console.log(newarr);
                return  newarr
            }
            return []
        },

    },
    data(){
            return{
                 weatherData:{},
                 forecastData:{},
                 today:moment().format('ddd,MMM D'),
                 breakpoints:0,
                 breakpointshalf:0,
                 breakpointsquater:0,
                 defautlTextWidth:0
            }
           },
           watch:{

            city(){
                // console.log(updatedValues)
                    this.initWeather()
            },
            unit(){
                // console.log(updatedValues)
                    this.initWeather()
            },

           },
           mounted(){
            // if(!this.weatherData?.base){
            //   console.log("here I am ")
            //   document.querySelector('[data-type="weatherApp"]').style.width = this.getActiveCanvas.size.width * this.zoom  + "px";
            // }
            this.initWeather();
            this.breakpoints = this.subtractPercentage(this.width , 20)
            this.breakpointshalf = this.subtractPercentage(this.width , 40)
            this.breakpointsquater = this.subtractPercentage(this.width , 65)

            // console.log(this.width);
            // console.log(this.width / this.zoom);
            // console.log(this.zoom);
            this.defautlTextWidth = this.width;

           },
           methods:{
            initWeather(){
                //
               console.log("calling")
                // const url = `https://api.open-meteo.com/v1/forecast?latitude=${this.city?.latitude}&longitude=${this.city?.longitude}&current=temperature_2m,weather_code,is_day&daily=temperature_2m_max,weather_code,sunrise,sunset,temperature_2m_min&timezone=auto&forecast_days=4${this.unit === "F" ? '&temperature_unit=fahrenheit' : ''}`
                // const url = `https://api.openweathermap.org/data/3.0/onecall?lat=${this.city?.latitude}&lon=${this.city?.longitude}&exclude=${'hourly'}&appid=${process.env.VUE_APP_OPEN_WEATHER_API_KEY}`
                const url = `https://api.openweathermap.org/data/2.5/weather?lat=${this.city?.latitude}&lon=${this.city?.longitude}&appid=${process.env.VUE_APP_OPEN_WEATHER_API_KEY}&units=${this.unit === 'C' ?  'metric' : ''}`
                const url2 = `https://api.openweathermap.org/data/2.5/forecast?lat=${this.city?.latitude}&lon=${this.city?.longitude}&appid=${process.env.VUE_APP_OPEN_WEATHER_API_KEY}&units=${this.unit === 'C' ?  'metric' : ''}`
                let self = this;
            axios({
                method: 'get',
                url: url,

            }).then(function (response) {

                   self.weatherData = response.data;
                    // console.log(response)

                });
            axios({
                method: 'get',
                url: url2,

            }).then(function (response) {

                   self.forecastData = response.data;
                    // console.log(response)

                });
            },
            getDayName(date){
                let txt = date.split(" ")[0];
                return moment(txt).format("ddd")
            },
            T(des){
          let text = des.replace(" ", "_");
          return translateWeather[text.toLowerCase()][this.lang];
        },
            subtractPercentage(originalValue, percentage) {
                return originalValue - (originalValue * (percentage / 100));
            }
           }

}
</script>



<style scoped>

      h1 {
        color: white;
        text-align: center;
      }
      .col-4{
        color: white;
        font-weight: bold;
        /* font-size: 23px; */
        font-size: 2.3vw;
        text-align: center;
      }
     .w-65{
      width: 65%;
     }
      .addBG{
        margin: 0px;
      padding: 0px;
      box-sizing: border-box;
      background-color: aqua;
      background-size: cover;
      background-repeat: no-repeat;
      display: flex;
    flex-direction: column;
    justify-content: stretch;
    height: 100%;
      }
      .adjustBottomSection{
        flex: 1;
        width: 100%;
    /* display: flex;
    justify-content: center;
    align-items: center; */
      }
      .fontsize150 > h1{
        font-size: 80px;

      }
     .responsive_heading{
      font-size: 2.5vw;
      flex:1;
     }
     .responsive_heading.customer_name{
      font-size: 1.5vw;
      font-weight: 500;
     }
      .Overlay-side{
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        bottom: 0;
      }
      .Overlay-side.w-30{
        width: 30%;
      }
      .Overlay-side.w-30 .responsive_heading.customer_name{
        font-size: 1vw;
      }
      .Overlay-side.w-30 .responsive_heading{
        font-size: 1.5vw;
      }
      .Overlay-side.w-30 .flex-grow-half{
        flex-grow: 0.2;

      }
      .Overlay-side.w-100{
        bottom: unset;
      }
       .Overlay-side.w-100 .responsive_heading{
        font-size: 0.8vw;

      }
      .Overlay-side.w-100 .responsive_heading.customer_name{
        font-size: 0.5vw;

      }
      .Overlay-side.w-100 .adjustRIGHT {
        font-size: 0.6vw;
      }
      .adjustRIGHT{
        color: white;
        font-weight: bold;
        text-align: center;
      }
      .adjustRIGHT img{
        width: 40% !important;
      }
      .Overlay-side.w-100.w-0 {
        width: unset !important;
        left: 70%;
        padding: 7px;
      }
      .position-unset{
        position: unset !important;
      }
      .margin-top-minus{
        margin-top: -20px;

      }
      .margin-bottom-minus{
        margin-bottom: -20px;

      }
</style>